export default {
  amount: (state) => state.amount,
};
